import Layout from './components/layout';
import Details from './components/details';
import AlertLayout from '../alert/components/layout';

export default {
	Layout,
	Details,
	AlertLayout
}